import { countClass } from "./countClass";

export interface Component {
  Name?: string;
  Code?: string;
  Order?: number;

  [key: string]: any;
}

export interface ComponentScript {
  techMS: number;
  ScriptKind: number;
  NameWithPrefix: string;

  [key: string]: any;
}

export interface FunctionDef {
  Name: string;
  Body: string;
  Params: string;

  Components: Component[];
  ParametryAktualne: Parametr[];
  ParametryWejsciowe: Parametr[];
  CalculationsData:string[];
  Calculations: countClass[];
}

export interface FunctionScript {
  Name?: string;
  Script?: string;

  [key: string]: any;
}

export interface MaterialsData {
  [sectionName: string]: string;
}

export class Parametr {
  init(par: Parametr) {
    this.Nazwa = par.Nazwa;
    this.DziedzinaOpis = par.DziedzinaOpis;
    this.IsInput = par.IsInput;
    this.IsString = par.IsString;
    this.Wartosc = par.Wartosc;
  }
  Nazwa: string;
  Wartosc: string;
  DziedzinaOpis?: string;
  IsInput?: boolean;
  IsString?: boolean;

}
